import * as FlatModels from '@medsurf/flat-models';

// <editor-fold desc="Action Types">

/**
 * Action types
 */
export enum ActionTypes {
  /**
   * Store
   */
  GetReleaseNotes = '[STORE | AUTHOR | RELEASE-NOTE] Get Release Notes',
  GetReleaseNotesSuccess = '[STORE | AUTHOR | RELEASE-NOTE] Get Release Notes Success',
  /**
   * Request
   */
  GetReleaseNotesRequest = '[REQUEST | API | RELEASE-NOTE] Get Release Notes Request'
}

// </editor-fold>

// <editor-fold desc="Models">

// </editor-fold>

// <editor-fold desc="Store">


/**
 * Get Release Notes
 */
export class GetReleaseNotes {
  public static readonly type = ActionTypes.GetReleaseNotes;
}

/**
 * Get Release Notes Success
 */
export class GetReleaseNotesSuccess {
  public static readonly type = ActionTypes.GetReleaseNotesSuccess;

  public constructor(public releases: FlatModels.ReleaseNoteAuthorModels.Release[]) {
  }
}

// </editor-fold>

// <editor-fold desc="Request">

/**
 * Get Release Notes Request
 */
export class GetReleaseNotesRequest {
  public static readonly type = ActionTypes.GetReleaseNotesRequest;
}

// </editor-fold>
